import React from 'react';
import { CategoriesListing } from 'containers/categories-listing';
import { useCategoriesListingPage } from './hooks';

export const CategoriesListingPage = () => {
	useCategoriesListingPage();

	return <CategoriesListing />;
};
